// extracted by mini-css-extract-plugin
export default {"wrapper":"getCommunity_wrapper__5dV6T","loader":"getCommunity_loader__nJzqh"};